function parseDateStringToObject(dateString: string | null | undefined) {
    if (!dateString) {
        return { day: null, month: null, year: null }
    }

    const dateParts = dateString.split('-')
    if (dateParts.length !== 3 || dateParts[0].length !== 4 || dateParts[1].length !== 2 || dateParts[2].length !== 2) {
        console.error('Invalid date format or length', dateString)
        return { day: null, month: null, year: null }
    }

    const [year, month, day] = dateParts
    return {
        day: day.padStart(2, '0'),
        month: month.padStart(2, '0'),
        year,
    }
}

export default parseDateStringToObject
